<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow':
        control.elementVal.getValue()?.duringChange === 't' }">
    </div>
    <img class="control__img border-light"
         [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__icon': control.elementVal.getValue()?.duringChange === 'f' }"
         ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId) }}"
         width="72" height="72" alt="" />
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__label': control.elementVal.getValue()?.duringChange === 'f' }">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>

    <div class="control__content">
        <div class="control__range double">
            <div [ngSwitch]="control.elementVal.getValue()?.type">
                <p class="control__double-title color-basic font-16"
                   *ngSwitchCase="3">
                    {{ subtitle(414) }}
                </p>
                <p class="control__double-title color-basic font-16"
                   *ngSwitchCase="4">
                    {{ subtitle(283) }}
                </p>
            </div>

            <div class="control__value font-55 font-bold"
                [ngClass]="{ 'color-inactive': control.elementVal.getValue()?.duringChange === 't',
                    'color-style': control.elementVal.getValue()?.duringChange === 'f' }"
                data-testid="hourOrMinuteValue">
                {{ control.time.hour }}
            </div>
            <input class="control__input-range cursor-pointer"
                (change)="timeDate.changeHourMinute('hour',0)"
                type="range"
                [(ngModel)]="control.time.hour"
                min="0"
                max="{{ control.time.maxHour }}">
            <div class="control__remove cursor-pointer"
                data-testid="decreaseHourOrMinute">
                <hold-wrapper (onAction)="timeDate.changeHourMinute('hour',-1)">
                    <img ngSrc="/assets/img/icons/minus.svg"
                        width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
            <div class="control__add cursor-pointer"
                data-testid="increaseHourOrMinute">
                <hold-wrapper (onAction)="timeDate.changeHourMinute('hour',1)">
                    <img ngSrc="/assets/img/icons/plus.svg"
                        width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
        </div>

        <div class="control__range double">
            <div [ngSwitch]="control.elementVal.getValue()?.type">
                <p class="control__double-title color-basic font-16"
                   *ngSwitchCase="3">
                    {{ subtitle(685) }}
                </p>
                <p class="control__double-title color-basic font-16"
                   *ngSwitchCase="4">
                   {{ subtitle(414) }}
                </p>
            </div>

            <div class="control__value font-55 font-bold"
                [ngClass]="{ 'color-inactive': control.elementVal.getValue()?.duringChange === 't',
                    'color-style': control.elementVal.getValue()?.duringChange === 'f' }"
                data-testid="minuteOrSecondValue">
                {{ control.time.minute }}
            </div>
            <input class="control__input-range cursor-pointer"
                (change)="timeDate.changeHourMinute('minute',0)"
                   type="range"
                   [(ngModel)]="control.time.minute"
                   min="0"
                   max="59">
            <div class="control__remove cursor-pointer"
                data-testid="decreaseMinuteOrSecond">
                <hold-wrapper (onAction)="timeDate.changeHourMinute('minute',-1)">
                    <img ngSrc="/assets/img/icons/minus.svg"
                        width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
            <div class="control__add cursor-pointer"
                data-testid="increaseMinuteOrSecond">
                <hold-wrapper (onAction)="timeDate.changeHourMinute('minute',1)">
                    <img ngSrc="/assets/img/icons/plus.svg"
                         width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
        </div>
    </div>

    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                 ngSrc="/assets/img/zone_icons/back.svg"
                 width="40" height="40" alt="" />
        </button>
        <button class="control__button control__button--small bg-default"
            data-testid="resetButton"
            (click)="timeDate.setDefaultTime()">
            <img class="control__button-img"
                 ngSrc="/assets/img/icons/return.svg"
                 width="40" height="40" alt="" />
        </button>
        <button class="control__button"
            [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                'bg-ok': control.elementVal.getValue()?.duringChange === 'f',
                'bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                data-testid="sendButton"
                (click)="timeDate.returnTime()">
            <img class="control__button-img"
                 ngSrc="/assets/img/icons/ok.svg"
                 width="40" height="40" alt="" />
        </button>
    </div>

    <div *ngIf="control.elementVal.getValue()?.duringChange === 't'"
         class="control__during-change">
        <p class="color-alarm font-18">{{ subtitle(3162) }}</p>
    </div>
</div>
